var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pageRoot" }, [
    _c("h1", [_vm._v("TdsAppService Administration Homepage")]),
    _vm._v(" "),
    _c("p", [_vm._v("Please select a menu item above.")]),
    _vm._v(" "),
    _c(
      "p",
      { attrs: { title: "Status refreshes automatically every 5 seconds" } },
      [
        _vm._v(
          "IP2Location Database Update Status: " +
            _vm._s(_vm.ip2LocationDbUpdateStatus)
        ),
      ]
    ),
    _vm._v(" "),
    _c("p", [
      _vm._v("IP2Location Database Update Manual Override: "),
      _c("button", { on: { click: _vm.manuallyTriggerIp2LocationDbUpdate } }, [
        _vm._v("Trigger Now"),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }